import type {ProjectType } from "@/entities/projects/model/types";
import TransparentButton from "@/shared/ui/buttons/TransparentButton";
import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";
import { Map } from "@/widgets/map/ui/Map";

import { useAppDispatch } from "@/app/store/hooks";
import { requestFormModalOpen } from "@/widgets/modal/model/slice";
import CalculatorButton from "@/shared/ui/buttons/CalculatorButton";

export interface IProjectMapSectionProps {
    project: ProjectType
}

export function ProjectMapSection({project}: IProjectMapSectionProps) {

    const dispatch = useAppDispatch();

    const handleSignUpForViewing = () => {
        dispatch(
            requestFormModalOpen({
                title: 'записаться на просмотр',
                text: 'Оставьте свои контактные данные, чтобы получить доступ к нашей уникальной подборке топовых объектов. Выберите удобный способ скачивания, и презентация будет доступна в считанные минуты',
            })
        );
    };

    return (
        <SectionLayout 
            className=""
            containerClassName="pt-[40px] pb-[20px] lg:pt-[60px] xl:py-[40px] flex flex-col lg:flex-row gap-[20px] md:gap-[28px]"
        >
            <Map
                projects={[project]}
                wpClassName="lg:max-w-[510px] xl:max-w-[610px]"
                className="h-[250px] md:h-[300px] lg:h-full rounded-[10px]"   
            />

            <div className="flex flex-col gap-[20px] md:gap-[28px] lg:gap-[40px] xl:gap-[56px]">
                <TransparentButton className="p-[10px] w-fit bg-light-blue font-normal text-[10px] md:text-[14px] cursor-default">
                    Расположение
                </TransparentButton>
                
                <Typography tag="h2" className="">
                    {project.location.additional.title}
                </Typography>

                <div className="flex flex-col gap-[22px] md:flex-row">
                    <div className="flex flex-col gap-[12px]">
                        <Typography className="uppercase whitespace-nowrap text-[16px] md:text-[18px] font-semibold">
                            {project.location.additional.descriptions.first.subtitle}
                        </Typography>
                        <Typography className="text-black-50 text-[14px] md:text-[16px] font-medium">
                            {project.location.additional.descriptions.first.text}
                        </Typography>
                    </div>
                    <div className="flex flex-col gap-[12px]">
                        <Typography  className="uppercase whitespace-nowrap text-[16px] md:text-[18px] font-semibold">
                            {project.location.additional.descriptions.second.subtitle}
                        </Typography>
                        <Typography className="text-black-50 text-[14px] md:text-[16px] font-medium">
                            {project.location.additional.descriptions.second.text}
                        </Typography>
                    </div>
                </div>

                <CalculatorButton 
                    className="w-full"
                    onClick={handleSignUpForViewing}
                >
                    Записаться на просмотр
                </CalculatorButton>
            </div>
        </SectionLayout>
    )        
}
